{
  "entities": {
    "warehouses": "Almacén | Almacenes",
    "loadtypes": "Tipo de Carga | Tipos de Carga",
    "organizations": "Organización | Organizaciones",
    "orgs": "Org | Orgs"
  }
}
